import React, { createContext, useCallback, useEffect, useState } from "react";
import { fetchCurrentUser, login as loginRequest, logout as logoutRequest } from "../api/authApi";
import { clearToken, getToken, setToken } from "../utils/tokenStorage";

export const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadCurrentUser = useCallback(() => {
    if (!getToken()) {
      setLoading(false);
      return;
    }
    fetchCurrentUser()
      .then((currentUser) => setUser(currentUser))
      .catch(() => {
        clearToken();
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    loadCurrentUser();
  }, [loadCurrentUser]);

  const login = async (username, password) => {
    const result = await loginRequest(username, password);
    setToken(result.accessToken);
    setUser(result.user);
    return result.user;
  };

  const logout = async () => {
    try {
      await logoutRequest();
    } finally {
      clearToken();
      setUser(null);
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
